import image from "../../assets/campusLife/campusLife3.jpg";
import { motion } from "framer-motion";

export default function AlumniAssociation() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-8">
        {/* Heading */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          className="text-center mb-16"
        >
          <motion.p
            variants={itemVariants}
            className="text-sm font-medium tracking-wider uppercase text-gray-600 mb-4"
          >
            About Us
          </motion.p>

          <motion.h2
            variants={itemVariants}
            className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6"
          >
            Our Alumni Association
          </motion.h2>

          <motion.p
            variants={itemVariants}
            className="text-gray-600 max-w-3xl mx-auto leading-relaxed"
          >
            The Alumni Association is a lifelong network of graduates dedicated
            to strengthening connections, fostering opportunities, and giving
            back to the university community. Together, we celebrate our shared
            history while shaping the future.
          </motion.p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <img
              src={image}
              alt="Alumni gathering"
              className="w-full h-auto rounded-2xl shadow-lg"
            />
          </motion.div>

          {/* Right - Info Cards */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-6"
          >
            {/* Card 1 */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-100">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Our Mission
              </h3>
              <p className="text-gray-600 text-sm">
                To build a strong and supportive alumni community, inspire the
                next generation of students, and uphold the values of our
                institution through service, mentorship, and collaboration.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-100">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                What We Do
              </h3>
              <ul className="text-gray-600 text-sm space-y-2 list-disc pl-5">
                <li>Host reunions and networking events</li>
                <li>Provide mentorship and career guidance</li>
                <li>Support scholarships and fundraising initiatives</li>
                <li>Create opportunities for professional growth</li>
              </ul>
            </div>

            {/* Card 3 */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-100 flex items-center justify-between">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Stay Connected
                </h3>
                <p className="text-gray-600 text-sm">
                  Be part of our growing alumni network and never miss an
                  opportunity to connect, collaborate, and contribute.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
